import { render, staticRenderFns } from "./BaseCopyright.vue?vue&type=template&id=05729406&scoped=true&"
var script = {}
import style0 from "./BaseCopyright.vue?vue&type=style&index=0&id=05729406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05729406",
  null
  
)

export default component.exports